import { create } from 'zustand'
import { PopoverProperty } from '@/components/common/propertyPopoverOverlay/Property.tsx'

export type ProjectStageFiltersT = {
  stagesProperties: PopoverProperty[]
  archiveProps: PopoverProperty[]
  reportsFilters: PopoverProperty[]
  notificationsFilters: PopoverProperty[]
  issueTypeProperty: PopoverProperty
  users: PopoverProperty[]
  labelGroupsProperties: PopoverProperty[]
  statusGroupsProperties: PopoverProperty[]
  locationProperties: PopoverProperty[]
}

type ProjectStageFiltersStoreT = {
  stagesProperties: PopoverProperty[]
  archiveProps: PopoverProperty[] | null
  reportsFilters: PopoverProperty[] | null
  notificationsFilters: PopoverProperty[] | null
  setFilters: (filters: ProjectStageFiltersT) => void
  users: PopoverProperty[]
  issueTypeProperty: PopoverProperty | null
  statusGroupsProperties: PopoverProperty[]
  labelGroupsProperties: PopoverProperty[]
  locationProperties: PopoverProperty[]
}

export const useProjectStageFiltersStore = create<ProjectStageFiltersStoreT>(set => ({
  stagesProperties: [],
  archiveProps: null,
  reportsFilters: null,
  notificationsFilters: null,
  allFiltersProperties: [],
  setFilters: filters =>
    set(() => {
      // console.log(`properties: `, filters)
      return {
        reportsFilters: filters.reportsFilters,
        stagesProperties: filters.stagesProperties,
        archiveProps: filters.archiveProps,
        notificationsFilters: filters.notificationsFilters,
        issueTypeProperty: filters.issueTypeProperty,
        statusGroupsProperties: filters.statusGroupsProperties,
        labelGroupsProperties: filters.labelGroupsProperties,
        users: filters.users,
        locationProperties: filters.locationProperties,
      }
    }),
  users: [],
  issueTypeProperty: null,
  statusGroupsProperties: [],
  labelGroupsProperties: [],
  locationProperties: [],
}))
